import * as selectors from './syncs.selectors';
import reducer from './syncs.reducers';

export default reducer;
export { selectors, reducer };
export { SyncAction } from './syncs.actions';
export { SyncEffects } from './syncs.effects';
export { Sync, SyncState } from './syncs.models';
export { SyncService } from './syncs.service';
